import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Search from "./Search";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="container">
      <Search />
    </div>
    <p className="tag">
      This project was coded by Callie👽 and is{" "}
      <a
        href="https://github.com/Callietron300/dictionary-app"
        target="_blank"
        rel="noreferrer"
      >
        open source
      </a>
      <br />
      Design inspired by{" "}
      <a href="https://dribbble.com/an-yr" target="_blank" rel="noreferrer">
        Angela Yun's
      </a>{" "}
      <a
        href="https://dribbble.com/shots/17252995-Dictionary-App-v2/attachments/12360453?mode=media"
        target="_blank"
        rel="noreferrer"
      >
        Dictionary App Design
      </a>
      .
    </p>
  </React.StrictMode>
);
